import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { ReportConfigDataModelValue } from './ReportConfigDataModelValue';

import type { PhaseSwitcher } from './PhaseSwitcher';
import type { IConfigProps, IReportValueAccessor } from './interfaces';
import type { IValue } from '@/engine/DataFlow/Graph';

/**
 * Represents a value accessor for the report data model (Algorithm accessor).
 */
export class ReportDataModelValueAccessor implements IReportValueAccessor {
  private _planingAlgorithm: PlanningAlgorithm;

  private _phaseSwitcher: PhaseSwitcher;

  public constructor(planningAlgorithm: PlanningAlgorithm, phaseSwitcher: PhaseSwitcher) {
    this._planingAlgorithm = planningAlgorithm;
    this._phaseSwitcher = phaseSwitcher;
  }

  /**
   * Retrieves the value from the report data model based on the provided configuration entry.
   * @param configEntry The configuration entry for the report data model value.
   * @returns A promise that resolves to the value retrieved from the report data model.
   */
  public async getValueByConfig(config: IConfigProps): Promise<unknown> {
    if (config.phase === 'endSystole' || config.phase === 'endDiastole') {
      await this._phaseSwitcher.switchPhaseByKind(config.phase);
    }
    const configEntry = config as ReportConfigDataModelValue<IValue>;
    return await this._planingAlgorithm.getValueAsync(configEntry.path, configEntry.dataType);
  }
}
